'use client'

import { Tabs as TabsPrimitive } from '@base-ui/react/tabs'
import { cn } from '@nt/ui/cn'
import { tabsRecipe } from '@nt/ui/recipes'
import { cva, type VariantProps } from 'class-variance-authority'

function Tabs({ className, orientation = 'horizontal', ...props }: TabsPrimitive.Root.Props) {
  return (
    <TabsPrimitive.Root
      data-slot="tabs"
      data-orientation={orientation}
      data-horizontal={orientation === 'horizontal' ? '' : undefined}
      data-vertical={orientation === 'vertical' ? '' : undefined}
      className={cn('gap-2 group/tabs flex data-horizontal:flex-col', className)}
      {...props}
    />
  )
}

// `default`: a pill track on the surface with the active tab raised in white;
// `line`: tabs on a rule, the active one underlined in the service accent.
const tabsListVariants = cva(tabsRecipe.list.base, {
  variants: {
    variant: {
      default: tabsRecipe.list.default,
      line: tabsRecipe.list.line,
    },
  },
  defaultVariants: {
    variant: 'default',
  },
})

function TabsList({
  className,
  variant = 'default',
  ...props
}: TabsPrimitive.List.Props & VariantProps<typeof tabsListVariants>) {
  return (
    <TabsPrimitive.List
      data-slot="tabs-list"
      data-variant={variant}
      className={cn(tabsListVariants({ variant }), className)}
      {...props}
    />
  )
}

function TabsTrigger({ className, ...props }: TabsPrimitive.Tab.Props) {
  return <TabsPrimitive.Tab data-slot="tabs-trigger" className={cn(tabsRecipe.trigger, className)} {...props} />
}

function TabsContent({ className, ...props }: TabsPrimitive.Panel.Props) {
  return <TabsPrimitive.Panel data-slot="tabs-content" className={cn(tabsRecipe.content, className)} {...props} />
}

export { Tabs, TabsContent, TabsList, tabsListVariants, TabsTrigger }
